import styled from 'styled-components'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Button } from '@dsny/dsny-component-library'
import { BREAKPOINT_QUERIES } from 'styles/breakpoints'

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 24px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    gap: 16px;
    min-height: 44px;
  }
`

export const SearchField = styled.form`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  flex: 0 0 100%;
  order: 1;

  input::placeholder {
    color: ${({ theme }) => theme.colors.neutralW70};
    opacity: 1;
  }

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    display: block;
    flex: 0 1 336px;
    order: 0;
  }
`

export const SearchToggle = styled.button`
  align-items: center;
  color: ${({ theme }) => theme.colors.neutralW100};
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.player50};
  }

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    display: none;
  }
`

export const FilterLabel = styled.span`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
`

export const SortTrigger = styled(DropdownMenu.Trigger)`
  background: #393939;
  border: 0;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.neutralW90};
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  gap: 4px;
  line-height: 16px;
  min-height: 24px;
  padding: 4px 4px 4px 8px;
  white-space: nowrap;

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.player50};
  }
`

export const SortMenu = styled(DropdownMenu.Content)`
  background: #222;
  border: 0.5px solid #393939;
  border-radius: 5px;
  color: #f5f5f5;
  min-width: 160px;
  padding: 8px 0;
  z-index: 9999;
`

export const SortOption = styled(DropdownMenu.RadioItem)`
  cursor: pointer;
  font-size: 14px;
  outline: none;
  padding: 8px 16px;

  &[data-highlighted],
  &[data-state='checked'] {
    background: #393939;
  }
`

export const LibraryCreateButton = styled(Button)`
  flex-shrink: 0;
  gap: 8px;
  margin-left: auto;
  min-height: 24px;
  padding: 4px 8px;

  svg {
    height: 16px;
    width: 16px;
  }

  @media ${BREAKPOINT_QUERIES.mobileDown} {
    background: #393939;
    border: 0;
    color: ${({ theme }) => theme.colors.neutralW90};
    font-size: 12px;
    gap: 4px;
    line-height: 16px;
  }

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    height: 36px;
    line-height: 20px;
    min-height: 36px;
    padding: 8px 16px;
  }
`

export const CreateIcon = styled.span`
  align-items: center;
  display: inline-flex;
  order: 1;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    order: 0;
  }
`

export const CompactCreateLabel = styled.span`
  display: inline;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    display: none;
  }
`

export const FullCreateLabel = styled.span`
  display: none;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    display: inline;
  }
`
